import React, { useEffect, useState } from "react";
import Draggable from 'react-draggable';
import * as BosWebGuiServices from "data/BosWebServices/BosWebGuiServices";
import ContentLoadingBOS from "components/ContentLoadingBos";

// Externals
import cn from "classnames";

// DevExtreme components
import { TextBox } from 'devextreme-react';
import Button from 'devextreme-react/button';

// Component styles
import classes from "./SessionSettings.module.scss";

function SessionSettings(props) {

  const { title, sessionId, dataSegmentAuthToken, reloadViewport, closeSettings } = props;
  const [settings, setSettings] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [draggable, setDraggable] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);

      try {
        console.log("GetSettings with sessionId:", sessionId);
        let result = await BosWebGuiServices.fetchGetSettings(dataSegmentAuthToken, sessionId);
        console.log("GetSettings result: ", result);
        setSettings(result);
      } catch (error) {
        console.error("GetSettings error: ", error);
        setSettings();
        setErrorMessage(error.toString());
      }
      setIsLoading(false);
    }

    fetchData();

    //cleanup
    return () => { };
  }, []);

  async function saveSettingsAndReload(event) {
    setErrorMessage();
    try {
      console.log("SetSettings with sessionId:", sessionId, settings);
      let result = await BosWebGuiServices.fetchSetSettings(
        dataSegmentAuthToken,
        sessionId,
        settings.typeface,
        parseInt(settings.fontSize),
        parseFloat(settings.defaultRowHeight),
        parseFloat(settings.defaultWidgetDistance),
        parseFloat(settings.labelControlDistance),
        parseFloat(settings.floatingLabelFactor),
        parseFloat(settings.navigationControlWidth),
        parseFloat(settings.viewportHeight),
        parseFloat(settings.viewportWidth)
      );
      console.log("SetSettings result: ", result);
    } catch (error) {
      console.error("SetSettings error: ", error);
      setErrorMessage(error.toString());
    }
    reloadViewport();
  }

  async function setSetting(id, value) {
    setSettings(prev => {
      return { ...prev, [id]: value };
    });
  }

  const onHover = () => {
    console.log("BeginDrag");
    setDraggable(true);
  }
  const onEndDrag = () => {
    console.log("EndDrag");
    setDraggable(false);
  }

  const paperStyle = () => ({
    zIndex: 9000,
    top: "4em",
    right: "2em",
  });

  const toEffectiveLabel = (label) => {
    switch (label) {
      case "defaultRowHeight":
        return "Row Height";
      case "defaultWidgetDistance":
        return "Widget Distance";
      case "labelControlDistance":
        return "Label Control Distance";
      default:
        return null;
    }
  }

  const renderSetting = (label, value, id) => {
    if (id === "errorMessage") {
      return <React.Fragment key={"fragment" + id} />;
    }
    let effectiveLabel = toEffectiveLabel(label);
    if (!effectiveLabel) {
      return <React.Fragment key={"fragment" + id} />;
    }
    let content = value || "";
    return (
      <React.Fragment key={"fragment" + id}>
        <div key={"label" + id} className={classes.label}>
          {effectiveLabel}
        </div>
        <TextBox
          key={"field" + id}
          value={content}
          onValueChanged={e => setSetting(id, e.value)}
        />
      </React.Fragment>
    );
  };

  const renderSettingsForm = () => {
    return (
      <React.Fragment>
        <form>
          {Object.keys(settings).map(key => renderSetting(key, settings[key], key))}
        </form>
        <div className={classes.errorLabel}>
          {errorMessage}
        </div>
        <Button
          className={classes.saveButton}
          onClick={saveSettingsAndReload}
          text={"Save and Reload"}
        />
      </React.Fragment>
    );
  };

  const renderHeaderButton = (icon, onClickHandler) => {
    return (
      <Button
        stylingMode={'text'}
        icon={icon}
        className={classes.titleButton}
        onClick={onClickHandler}
      />
    );
  };

  return (
    <Draggable disabled={!draggable}>
      <div className={classes.settingsPaper} style={paperStyle()}>
        <div className={classes.titleContainer} onMouseOver={onHover} onMouseLeave={onEndDrag} style={{ cursor: "move" }}>
          <div>
            {title}
          </div>
          {renderHeaderButton('close', closeSettings)}
        </div>
        <div className={cn(classes.settingsContainer, "dx-theme-background-color")}>
          {isLoading
            ? <ContentLoadingBOS />
            : renderSettingsForm()}
        </div>
      </div>
    </Draggable>
  );
}

export default SessionSettings;
